import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import styles from './EnergySlider.module.css';

interface EnergySliderProps {
  value: number;
  onChange: (value: number) => void;
  onSubmit: () => void;
}

const MIN = 1;
const MAX = 5;

// PARA-105, AC-3: слайдер уровня энергии (1-5) + кнопка "Подобрать задачу".
// PARA-122 (D9, AC-9): кастомный трек/заливка/кнобик по образцу
// components/procrastination/EnergySlider.jsx (трек 6px --track, заливка --accent,
// белый knob 28px с рамкой 2px --accent) + подписи концов low/high. Нативный
// <input type="range"> сохранён (прозрачный оверлей) — доступность и контракт e2e.
export function EnergySlider({ value, onChange, onSubmit }: EnergySliderProps): JSX.Element {
  const { t } = useTranslation('procrastination');
  const pct = ((value - MIN) / (MAX - MIN)) * 100;

  return (
    <div className={styles.wrapper}>
      <label className={styles.label} htmlFor="energy-slider">
        {t('energy.label')}
      </label>
      <div className={styles.control}>
        <div className={styles.trackRow}>
          <div className={styles.track} />
          <div className={styles.fill} style={{ width: `${pct}%` }} />
          <div className={styles.knob} style={{ left: `${pct}%` }} />
          <input
            id="energy-slider"
            className={styles.input}
            type="range"
            min={MIN}
            max={MAX}
            value={value}
            onChange={(event) => onChange(Number(event.target.value))}
          />
        </div>
        <div className={styles.ends}>
          <span>{t('energy.low')}</span>
          <span>{t('energy.high')}</span>
        </div>
      </div>
      <Button variant="primary" fullWidth onClick={onSubmit}>
        {t('energy.submit')}
      </Button>
    </div>
  );
}
